import { render } from "./correspondence.vue?vue&type=template&id=2bd8f051&scoped=true"
import script from "./correspondence.vue?vue&type=script&lang=js"
export * from "./correspondence.vue?vue&type=script&lang=js"

import "./correspondence.vue?vue&type=style&index=0&id=2bd8f051&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bd8f051"]])

export default __exports__